import React, { useState } from "react";

const SyntraMfgLeadHub = () => {
  const [leads, setLeads] = useState([
    {
      id: 1,
      title: "500 Units Aluminum Sheets",
      type: "Sale",
      category: "Raw Material",
      location: "Pune, Maharashtra",
      status: "New",
    },
    {
      id: 2,
      title: "Contract Manufacturing Inquiry for Widgets",
      type: "Service Request",
      category: "Manufacturing Service",
      location: "Bengaluru, Karnataka",
      status: "In Progress",
    },
    {
      id: 3,
      title: "Export Inquiry: Stainless Steel Bolts",
      type: "Export",
      category: "Finished Goods",
      location: "Dubai, UAE",
      status: "New",
    },
    {
      id: 4,
      title: "Machinery Rental Request",
      type: "Rental",
      category: "Machinery / Equipment",
      location: "Ahmedabad, Gujarat",
      status: "Closed",
    },
  ]);

  const [newLead, setNewLead] = useState({
    title: "",
    type: "",
    category: "",
    location: "",
    status: "New",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewLead({ ...newLead, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!newLead.title || !newLead.type || !newLead.category || !newLead.location) {
      alert("Please fill in all fields before submitting.");
      return;
    }
    setLeads([...leads, { id: leads.length + 1, ...newLead }]);
    setNewLead({ title: "", type: "", category: "", location: "", status: "New" });
  };

  return (
    <div>
      <section className="py-2 px-2 bg-gradient-to-r from-gray-500 to-gray-700 min-h-screen">
        <div className="text-center mb-12">
          <h1 className="text-2xl md:text-3xl font-bold text-yellow-200 mb-4">
            🏭 SyntraMfg Enquiry Hub
          </h1>
          <p className="text-white max-w-2xl mx-auto">
            Manage all your manufacturing opportunities — sales, purchases, rentals, services, and global trade leads — in one place.
          </p>
        </div>

        {/* Form to Create New Lead */}
        <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-2xl p-6 mb-12">
          <h2 className="text-xl font-semibold text-gray-700 mb-4">Create New Enquiry</h2>
          <form onSubmit={handleSubmit} className="grid gap-4">
            <input
              type="text"
              name="title"
              value={newLead.title}
              onChange={handleChange}
              placeholder="Lead Title (e.g., 200 Units Steel Bolts)"
              className="border rounded-lg px-3 py-2 w-full"
            />

            <select
              name="type"
              value={newLead.type}
              onChange={handleChange}
              className="border rounded-lg px-3 py-2 w-full h-10"
            >
              <option value="">Select Enquiry Type</option>
              <option>Sale</option>
              <option>Purchase</option>
              <option>Rental</option>
              <option>Service Request</option>
              <option>Export</option>
              <option>Import</option>
            </select>

            <select
              name="category"
              value={newLead.category}
              onChange={handleChange}
              className="border rounded-lg px-3 py-2 w-full h-10"
            >
              <option value="">Select Category</option>
              <option>Raw Material</option>
              <option>Finished Goods</option>
              <option>Machinery / Equipment</option>
              <option>Manufacturing Service</option>
              <option>Export-Import</option>
            </select>

            <input
              type="text"
              name="location"
              value={newLead.location}
              onChange={handleChange}
              placeholder="Location (e.g., Mumbai, Maharashtra)"
              className="border rounded-lg px-3 py-2 w-full"
            />

            <button
              type="submit"
              className="bg-gray-700 text-white py-2 rounded-lg hover:bg-gray-800 transition"
            >
              ➕ Add Enquiry
            </button>
          </form>
        </div>

        {/* Leads Table */}
        <div className="max-w-5xl mx-auto overflow-x-auto">
          <h2 className="text-2xl font-semibold text-yellow-200 mb-6">All Enquiries</h2>
          <table className="w-full border-collapse bg-gray-700 shadow-lg rounded-xl overflow-hidden">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th className="p-3 text-left">Title</th>
                <th className="p-3 text-left">Type</th>
                <th className="p-3 text-left">Category</th>
                <th className="p-3 text-left">Location</th>
                <th className="p-3 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {leads.map((lead) => (
                <tr key={lead.id} className="border-b hover:bg-gray-500">
                  <td className="p-3">{lead.title}</td>
                  <td className="p-3">{lead.type}</td>
                  <td className="p-3">{lead.category}</td>
                  <td className="p-3">{lead.location}</td>
                  <td className="p-3">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                        lead.status === "New"
                          ? "bg-gray-100 text-gray-700"
                          : lead.status === "In Progress"
                          ? "bg-yellow-100 text-yellow-700"
                          : "bg-green-100 text-green-700"
                      }`}
                    >
                      {lead.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Footer */}
      <footer className="mt-16 bg-gray-800 text-white py-8 px-4 sm:px-6 md:px-20 rounded-2xl">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm">
            &copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <a href="#about" className="text-white hover:text-gray-300 transition">About</a>
            <a href="#privacy" className="text-white hover:text-gray-300 transition">Privacy Policy</a>
            <a href="#terms" className="text-white hover:text-gray-300 transition">Terms of Use</a>
            <a href="#contact" className="text-white hover:text-gray-300 transition">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SyntraMfgLeadHub;
